import React from 'react';
import logoLight from '../../assets/images/Artboard 2.png';
import logoDark from '../../assets/images/Artboard 4(2).png';

interface BrandLogoProps {
  /** Size of the logo image (not used, kept for backward compat) */
  iconSize?: string;
  /** Text size — controls image height */
  textSize?: string;
  /** Extra classes on the root wrapper */
  className?: string;
}

/**
 * Canonical ClickCollab brand mark.
 * Uses Artboard 2 (light mode) and Artboard 4 (dark mode) logo images.
 */
const BrandLogo: React.FC<BrandLogoProps> = ({
  iconSize,
  textSize = 'text-xl',
  className = '',
}) => {
  // Map text size to image height
  const heightClass = textSize === 'text-2xl' ? 'h-12' : textSize === 'text-lg' ? 'h-8' : 'h-10';

  return (
    <div className={`flex items-center ${className}`}>
      {/* Light mode logo */}
      <img
        src={logoLight}
        alt="ClickCollab"
        className={`${heightClass} w-auto object-contain dark:hidden`}
      />
      {/* Dark mode logo */}
      <img
        src={logoDark}
        alt="ClickCollab"
        className={`${heightClass} w-auto object-contain hidden dark:block`}
      />
    </div>
  );
};

export default BrandLogo;
